import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from "react-router-dom";
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import {
  TextField, Button, Box, Typography, List, ListItem, ListItemText, ListItemButton, Divider, Badge, Avatar
} from '@mui/material';
import dmIcon from "../components/Icons/dmIcon.png";
import notificationIcon from "../components/Icons/notificationIcon.png";
import logo from "../components/Logo/Colloquia_Logo.png";
import Tooltip from '@mui/material/Tooltip';

function DirectMessagePage() {
    const history = useHistory();
    const location = useLocation();
    const { userId, username } = location.state || {};

    // state for search input
    const [searchQuery, setSearchQuery] = useState("");

    // state for search results
    const [results, setResults] = useState([]);

    const [typingTimeout, setTypingTimeout] = useState(null);
    

    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState("");

    const [conversations, setConversations] = useState([]); // all users you messaged
    const [selectedUser, setSelectedUser] = useState(null); // currently active chat user

    const [unreadCount, setUnreadCount] = useState(0);

    const [unreadByUser, setUnreadByUser] = useState({});

    const [newFollowersCount, setNewFollowersCount] = useState(0);
    const [notificationsCount, setNotificationsCount] = useState(0);
    const [newUpvoteCount, setNewUpvoteCount] = useState(0);
    const [newCommentsCount, setNewCommentsCount] = useState(0);

    const inputRef = useRef(null);
    const [inputHeight, setInputHeight] = useState(120); // safe default

    const messagesEndRef = useRef(null);

    // Fetch unread messages periodically
    useEffect(() => {
        const fetchUnread = async () => {
            try {
                const res = await axios.get("/messages/unread-count");
                setUnreadCount(res.data.count);
            } catch (err) {
                console.error("Error fetching unread count:", err);
            }
        };

        fetchUnread(); // initial fetch
        const interval = setInterval(fetchUnread, 5000); // refresh every 5s
        return () => clearInterval(interval);
    }, []);
    /*
    useEffect(() => {
        const fetchUnreadByUser = async () => {
            try {
                const res = await axios.get("/messages/unread-by-user");
                // convert array → map: { userId: count }
                const map = {};
                res.data.forEach(u => {
                    map[u.userId] = u.count;
                });
                setUnreadByUser(map);
            } catch (err) {
                console.error("Error fetching unread counts by user:", err);
            }
        };

        fetchUnreadByUser();
        const interval = setInterval(fetchUnreadByUser, 5000);
        return () => clearInterval(interval);
    }, []);
    */

    // Fetch unread counts every few seconds
    useEffect(() => {
        const fetchUnread = async () => {
            try {
                // Get total unread messages
                const totalRes = await axios.get("/messages/unread-count");
                setUnreadCount(totalRes.data.count || 0);

                // Get per-user unread counts
                const userRes = await axios.get("/messages/unread-by-user");
                // Convert array → map { userId: count }
                const unreadMap = {};
                userRes.data.forEach(u => unreadMap[u.userId] = u.count);
                setUnreadByUser(unreadMap);

            } catch (err) {
                console.error("Error fetching unread data:", err);
            }
        };

        fetchUnread();
        const interval = setInterval(fetchUnread, 5000);
        return () => clearInterval(interval);
    }, []);


    useEffect(() => {
        axios.get("/messages/conversations")
        .then(res => setConversations(res.data))
        .catch(err => console.error("Failed to load conversations", err));
    }, []);

    // Fetch messages whenever a user is selected
    useEffect(() => {
        if (!selectedUser?._id) return;

        axios
            .get(`/messages/${selectedUser._id}`)
            .then((res) => {
            setMessages(res.data);
            })
            .catch((err) => console.error("Error fetching messages:", err));
    }, [selectedUser]);

    useEffect(() => {
        if (!userId) return;
        // Get recipient username
        //axios.get(`/user/view/${userId}`).then(res => setUsername(res.data.username));

        // Load existing conversation
        axios.get(`/messages/${userId}`)
            .then(res => setMessages(res.data))
            .catch(err => console.error("Failed to load messages:", err));
    }, [userId]);

    useEffect(() => {
        const fetchCounts = async () => {
            try {
            // Fetch new followers count
            const followersRes = await axios.get("/user/new-followers-count");
            setNewFollowersCount(followersRes.data.newFollowersCount);

            // Fetch new upvotes count
            const upvotesRes = await axios.get("/user/new-upvotes-count");
            setNewUpvoteCount(upvotesRes.data.newUpvoteCount);

            // Fetch new comments count
            const commentsRes = await axios.get("/user/new-comments-count");
            setNewCommentsCount(commentsRes.data.newCommentsCount);

            // Combine into total notifications count 
            setNotificationsCount(
                followersRes.data.newFollowersCount + upvotesRes.data.newUpvoteCount + commentsRes.data.newCommentsCount
            );
            } catch (err) {
            console.error("Error fetching notification counts:", err);
            }
        };

        fetchCounts();
    }, []);

    useEffect(() => {
        if (!inputRef.current) return;

        const observer = new ResizeObserver((entries) => {
            const height = entries[0].contentRect.height;
            setInputHeight(height);
        });

        observer.observe(inputRef.current);

        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const handleSendMessage = async () => {
        //if (!newMessage.trim() || !selectedUser) return;
        if (!newMessage.trim()) return;
        try {
            const res = await axios.post(`/messages/send/${selectedUser?._id || userId}`, { content: newMessage });
            setMessages(prev => [...prev, res.data]);
            setNewMessage("");
        } catch (err) {
            console.error("Failed to send message:", err);
        }
    };

    // handle search requests
    // Auto search when user types
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchQuery(value);

        // Clear previous timer to debounce API calls
        if (typingTimeout) clearTimeout(typingTimeout);

        setTypingTimeout(
        setTimeout(() => {
            if (value.trim()) {
            axios
                .get(`/user/search?username=${value}`)
                .then((res) => setResults(res.data))
                .catch((err) => console.error("Search failed", err));
            } else {
            setResults([]);
            }
        }, 300) // wait 300ms after typing stops
        );
    };

    // go to selected profile
    const visitProfile = (userId) => {
        history.push(`/user/view/${userId}`);
    };

  return (
    <div
            style={{
                //padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >
            {/* Top Bar: Buttons in center, search bar at top-right */}
            {/*<div
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '30px',
            }}
            >*/}
            {/* Empty space on the left for symmetry */}
            {/*<div style={{ width: '260px' }}></div>*/}
            <Box
                sx={{
                    position: "sticky",
                    top: 0,
                    zIndex: 1200,
                    backgroundColor: "#FFFDF8",
                    //borderBottom: "1px solid rgba(0,0,0,0.08)",
                    px: 3,
                    py: 2
                }}
                >
                <Box
                    sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                    }}
                >

                    {/* Left spacer for symmetry */}
                    {/*<Box sx={{ width: 260 }} />*/}
                    <Box
            sx={{
                display: "flex",
                alignItems: "center",
                minWidth: 220, // keeps layout stable
            }}
        >
            <Tooltip
                title="Lady Wisdom"
                arrow
                followCursor
            >
                <Box
                    component="img"
                    src={logo}
                    alt="Colloquia Logo"
                    onClick={() => history.push("/home")}
                    sx={{
                        height: 125,
                        width: "auto",
                        borderRadius: "10px", // rounded edges
                        cursor: "pointer",
                        objectFit: "contain",
                    }}
                />
            </Tooltip>
        </Box>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/mainsocial/following')}
                    >
                        Main Social
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/Government/following')}
                    >
                        Government
                    </Button>
                    {/*<Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page3')}
                    >
                        Journalism
                    </Button>*/}
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/audiovisual')}
                    >
                        Voting Power
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/profile')}
                    >
                        Profile
                    </Button>
                </Box>
   
            {/* Right Section: Notifications + Chat + Search */}
            <Box
                sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5, // spacing between circle buttons and search bar
                }}
            >
                {/* Notifications Circle Button */}
                {/*<Button
                    sx={{
                    width: 42,
                    height: 42,
                    minWidth: 42,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    "&:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                    }}
                    onClick={() => history.push("/notificationsPage")}
                >
                    
                </Button>*/}
                {/* Notifications Circle Button */}
                <Badge
                    badgeContent={notificationsCount > 0 ? notificationsCount : null}
                    color="error"
                    overlap="circular"
                    //sx={{
                    //    position: "absolute",
                    //    bottom: -4,
                    //    left: "50%",
                     //   transform: "translateX(-50%)",
                    //}}
                    sx={{
                        position: "relative", // let Badge control its internal layout
                        "& .MuiBadge-badge": {
                        top: 4,      // adjust position of red bubble
                        right: 4,
                        }
                    }}
                >
                    {/* Notifications Circle Button */}
                    <Button
                        sx={{
                        width: 42,
                        height: 42,
                        minWidth: 42,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        "&:hover": {
                            backgroundColor: "#f5f5f5",
                        },
                        }}
                        onClick={() => history.push("/notificationsPage")}
                    >
                        <Box
                            component="img"
                            src={notificationIcon}
                            alt="Notifications"
                            sx={{
                                width: 20,     // control icon size
                                height: 20,
                                objectFit: "contain",
                                pointerEvents: "none", // prevents weird click behavior
                            }}
                        />
                    </Button>
                </Badge>
                {/* Chat Circle Button */}
                {/*<Button
                    sx={{
                    width: 42,
                    height: 42,
                    minWidth: 42,
                    borderRadius: "50%",
                    backgroundColor: "white",
                    border: "1px solid #ccc",
                    "&:hover": {
                        backgroundColor: "#f5f5f5",
                    },
                    }}
                    onClick={() => history.push("/directmessage")}
                >

                </Button>*/}
                <Badge
                    badgeContent={unreadCount > 0 ? unreadCount : null}
                    color="error"
                    overlap="circular"
                    //sx={{
                    //    position: "absolute",
                    //    bottom: -4,
                    //    left: "50%",
                     //   transform: "translateX(-50%)",
                    //}}
                    sx={{
                        position: "relative", // let Badge control its internal layout
                        "& .MuiBadge-badge": {
                        top: 4,      // adjust position of red bubble
                        right: 4,
                        }
                    }}
                >
                    <Button
                        sx={{
                        width: 42,
                        height: 42,
                        minWidth: 42,
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #ccc",
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        }}
                        onClick={() => {
                            setUnreadCount(0); // optionally reset when clicked
                            history.push("/directmessage");
                        }}
                    >
                        <Box
                            component="img"
                            src={dmIcon}
                            alt="Messages"
                            sx={{
                                width: 20,
                                height: 20,
                                objectFit: "contain",
                                pointerEvents: "none",
                            }}
                        />
        
                    </Button>
                </Badge>
            {/* Search Bar - Top Right */}
            <Box
                sx={{
                    position: 'relative', // parent container for absolute dropdown
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-end',
                    gap: 1,
                }}
            >
                <TextField
                    placeholder="Search"
                    variant="outlined"
                    size="small"
                    value={searchQuery}
                    onChange={handleSearchChange}
                    sx={{
                    borderRadius: '20px',
                    backgroundColor: '#fff',
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '20px',
                        padding: '0px 8px',
                    },
                    width: '180px',
                    }}
                />

                {/* Search Results - Absolutely positioned */}
                {/*{results.length > 0 && (
                    <List
                    sx={{
                        position: 'absolute',
                        top: '100%', // directly below the search bar
                        right: 0,    // align to right of search bar
                        width: '200px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        mt: 0.5,
                    }}
                    >
                    {results.map((user) => (
                        <ListItem
                        key={user._id}
                        button
                        onClick={() => visitProfile(user._id)}
                        sx={{
                            padding: '5px 10px',
                            '&:hover': { backgroundColor: '#eee' },
                        }}
                        >
                        <ListItemText
                            primary={user.username}
                            secondary={`${user.first_name} ${user.last_name}`}
                        />
                        </ListItem>
                    ))}
                    </List>
                )}*/}
                {results.length > 0 && (
                    <List
                    sx={{
                        position: 'absolute',
                        top: '100%', // directly below the search bar
                        right: 0,    // align to right of search bar
                        width: '200px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                        border: '1px solid #ccc',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                        zIndex: 10,
                        mt: 0.5,
                    }}
                    >
                {results.map((user) => (
                    <ListItemButton
                        key={user._id}
                        onClick={() => visitProfile(user._id)}
                        sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        px: 1.5,
                        py: 1,
                        '&:hover': { backgroundColor: '#eee' },
                        }}
                    >
                        {/* Profile Image */}
                        <Avatar
                        src={user.profileImageUrl}
                        alt={user.username}
                        sx={{ width: 36, height: 36 }}
                        />

                        {/* Text stack */}
                        <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
                        
                        {/* Full Name (top) */}
                        <Typography
                            sx={{
                            fontSize: "0.9rem",
                            fontWeight: 500,
                            color: "#333",
                            lineHeight: 1.2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                        >
                            {user.first_name} {user.last_name}
                        </Typography>

                        {/* Username (bottom with @) */}
                        <Typography
                            sx={{
                            fontSize: "0.8rem",
                            color: "#666",
                            lineHeight: 1.2,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            }}
                        >
                            @{user.username}
                        </Typography>

                        </Box>
                    </ListItemButton>
                    ))}
                     </List>
                )}
            </Box>
            </Box>
            </Box>
            </Box>
      {/*<div style={{ padding: "20px", minHeight: "100vh", position: "relative"  }}>*/}
      <div
        style={{
            display: "flex",
            justifyContent: "center", // center horizontally on screen
            alignItems: "flex-start", // align top
            minHeight: "100vh",
            //backgroundColor: "#fafafa",
            padding: "20px",
        }}
        >
        {/* Sidebar */}
        {/*}
        <Box
            sx={{
            width: 250,
            borderRight: "1px solid #ccc",
            overflowY: "auto",
            //bgcolor: "#f9f9f9",
            }}
        >*/}
        <Box
            sx={{
            position: "fixed",
            //top: 0,
            left: 0,
            width: 250,
            height: "50vh",
            borderRight: "1px solid #ccc",
            overflowY: "auto",
            //bgcolor: "#f9f9f9",
            zIndex: 10,
            }}
        >
            <Typography variant="h6" sx={{ p: 2, textAlign: "center" }}>
                Messages
            </Typography>
            <Divider />
            {/*<List>
            {conversations.map((user) => (
                <ListItemButton
                    key={user._id}
                    selected={selectedUser?._id === user._id}
                    onClick={() => setSelectedUser(user)}
                >
                        @{user.username}
                </ListItemButton>
            ))}
            </List>*/}
            {/*<List>
                {conversations.map((user) => (
                    <ListItemButton
                    key={user._id}
                    selected={selectedUser?._id === user._id}
                    onClick={() => setSelectedUser(user)}
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                    >
                    <Typography>@{user.username}</Typography>

                    {unreadByUser[user._id] > 0 && (
                        <Badge
                        badgeContent={unreadByUser[user._id]}
                        color="error"
                        sx={{ "& .MuiBadge-badge": { right: 10 } }}
                        />
                    )}
                    </ListItemButton>
                ))}
                </List>*/}
                <List>
                    {conversations.map((user) => (
                        <ListItemButton
                            key={user._id}
                            selected={selectedUser?._id === user._id}
                            onClick={async () => {
                                setSelectedUser(user);
                                try {
                                    await axios.post(`/messages/mark-read/${user._id}`);
                                    // Immediately clear badge for that user in state
                                    setUnreadByUser(prev => ({ ...prev, [user._id]: 0 }));

                                    // Recalculate total unread count
                                    setUnreadCount(prev =>
                                        Math.max(0, prev - (prev[user._id] || 0))
                                    );
                                } catch (err) {
                                    console.error("Error marking messages read:", err);
                                }
                            }}
                            sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                            >
                            <Typography>@{user.username}</Typography>
                            {unreadByUser[user._id] > 0 && (
                                <Badge
                                    badgeContent={unreadByUser[user._id]}
                                    color="error"
                                    sx={{ "& .MuiBadge-badge": { right: 10 } }}
                                />
                            )}
                        </ListItemButton>
                    ))}
                    </List>
        </Box>
        {!userId && !selectedUser ? (
            <p>No user selected for messaging.</p>
        ) : (
            <>
            <Box
                sx={{
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    //bgcolor: "#f5f5f5",
                    maxWidth: 800,
                    width: "100%",
                    mx: "auto",
                }}
                >
                {/* Header */}
                {/*<Box
                    sx={{
                    p: 2,
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#fff",
                    textAlign: "center",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    }}
                >
                    Chat with {username}
                </Box>*/}

                {/* Scrollable message area */}
                <Box
                    sx={{
                    flex: 1,
                    overflowY: "auto",
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 1.5,
                    //pb: 10, // leave room for input box
                    pb: `${inputHeight + 60}px`,
                    }}
                >
                    {messages.length === 0 ? (
                    <Typography variant="body2" sx={{ color: "#888", textAlign: "center", mt: 4 }}>
                        No messages yet. Start the conversation!
                    </Typography>
                    ) : (
                    messages.map((msg, i) => (
                        <Box
                            key={i}
                            sx={{
                                display: "flex",
                                justifyContent: msg.fromSelf ? "flex-end" : "flex-start",
                            }}
                        >
                            <Box
                                //key={i}
                                sx={{
                                    //alignSelf: msg.fromSelf ? "flex-end" : "flex-start",
                                    bgcolor: msg.fromSelf ? "#1976d2" : "#e0e0e0",
                                    color: msg.fromSelf ? "#fff" : "#000",
                                    borderRadius: 2,
                                    p: 1.2,
                                    maxWidth: "75%",
                                    wordBreak: "break-word",
                                    //mr: msg.fromSelf ? "450px" : "0px",  // move self messages slightly inward
                                    //ml: msg.fromSelf ? "0px" : "450px",  // move other messages slightly inward
                                    //mr: msg.fromSelf ? "0px" : "350px",  // move self messages slightly inward
                                    //ml: msg.fromSelf ? "350px" : "0px",  // move other messages slightly inward
                                }}
                            >
                                {msg.content}
                                <Typography
                                    //variant="caption"
                                    //color={msg.fromSelf ? "rgba(255,255,255,0.7)" : "text.secondary"}
                                    //sx={{ display: "block", mt: 0.5, textAlign: "right" }}
                                    variant="caption"
                                    sx={{
                                        display: "block",
                                        mt: 0.5,
                                        textAlign: "right",
                                        color: msg.fromSelf
                                        ? "rgba(255,255,255,0.7)"
                                        : "text.secondary",
                                    }}
                                    >
                                        {new Date(msg.created_at).toLocaleString()}
                                </Typography>
                            </Box>
                        </Box>
                    ))
                    )}
                    <div ref={messagesEndRef} />
                </Box>
            {/*<h2>Chat with {username}</h2>*/}
            {/* Message sending UI goes here */}
            <Box
                  ref={inputRef}
                  p={2} // padding inside box
                  my={2} // vertical margin between posts
                  border="1px solid #ccc" // light grey border
                  borderRadius="8px" // rounded corners
                  //sx={{
                  //    position: "relative",
                  //    maxWidth: 900, // limit width
                  //    mx: "auto", // center horizontally
                  //    my: 2, // vertical spacing between each post
                  //}}
                  sx={{
                    position: "fixed",
                    bottom: 20, // distance from bottom
                    left: "50%", // center horizontally
                    transform: "translateX(-50%)", // offset for true center
                    //backgroundColor: "#fff",
                    backgroundColor: "#FFFDF8",
                    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    width: "90%", // responsive width
                    maxWidth: 800, // cap max width
                    zIndex: 10, // ensure it’s above other content
                    }}
                  /*sx={{
                    borderTop: "1px solid #ddd",
                    p: 2,
                    backgroundColor: "#FFFDF8",
                    position: "sticky",
                    bottom: 0,
                    zIndex: 1,
                    }}*/
              >
              <TextField
                  fullWidth
                  multiline
                  rows={2}
                  //placeholder={`Send message to @${selectedUser.username}...`}
                  placeholder={`Send message to @${selectedUser?.username || username}...`}
                  value={newMessage}
                  onChange={(e) => setNewMessage(e.target.value)}
              />
              <Button variant="outlined" sx={{ mt: 1 }} onClick={handleSendMessage}>
                  Send
              </Button>
              </Box>
              </Box>
            </>
        )}
      </div>
    </div>
  );
}

export default DirectMessagePage;
